 
<template>
  <div>
    <b-modal 
        v-model="authActivityModal"
        hide-footer
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :hide-header-close="true"
        :hide-header="true"
        >
        <b-container class="modal-content" fluid>
            <div class="row justify-content-center">
                <div class="col-lg-12 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-body px-lg-5 py-lg-5">
                    <br />
                    <form role="form" @submit.prevent="authorize">

                        <div class="row mt--3">
                        <div class="col">
                            <base-input label="Username">
                            <a-input
                                placeholder="Username/Email"
                                v-model="formData.username"
                            />
                            <div v-if="$v.formData.username.$dirty" class="text-danger">
                                <div class="error" v-if="!$v.formData.username.required">
                                Field is required
                                </div>
                            </div>
                            </base-input>
                        </div>
                        </div>

                        <div class="row mt--3">
                        <div class="col">
                            <base-input label="Password">
                            <a-input-password
                                placeholder="Password"
                                v-model="formData.password"
                            />
                            <div v-if="$v.formData.password.$dirty" class="text-danger">
                                <div class="error" v-if="!$v.formData.password.required">
                                Field is required
                                </div>
                            </div>
                            </base-input>
                        </div>
                        </div>

                        <div class="text-center">
                        <base-button
                            type="primary"
                            class="my-4"
                            nativeType="submit"
                            :disabled="formSubmitting"
                            style="width: 50%"
                        >
                            <a-spin v-if="formSubmitting" :spinning="formSubmitting" />
                            <span v-else>Authenticate</span>
                        </base-button>
                        <base-button
                            type="danger"
                            class="my-4"
                            style="width: 50%"
                            @click="closeModal()"
                        > Cancel
                        </base-button>
                        </div>
                    </form>
                    </div>
                </div>
                </div>
            </div>
        </b-container>
    </b-modal>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';


export default {
    name: 'AuthorizeActivity',
    props:{
        authActivityModal: {
            type: Boolean,
            default: false
        },
        memberShipProgramId: {
            required: true
        },
        url: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            formData: {
                username: '',
                password: '',
            },
            formSubmitting: false,
        };
    },
    validations: {
        formData: {
            username: { required },
            password: { required },
        }
    },
  methods:{
    closeModal: function() {
        this.$emit('closeModal', {status: false})
    },
    authorize: async function() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        // TODO: Front-end validation
        this.formData['memberShipProgramId'] = this.memberShipProgramId;
        try {
          const response = await HTTPRequest.postRequest(this.url, this.formData);
          if (response.status == 'success') {
            this.$emit('closeModal', {status: true, userId: response.userId})
            this.$notification.success({
              message: 'Success'
            });
          }
          if(response.error) {
            this.$notification.error({
                message: response.error
            });  
          }
        } catch (e) {
          this.$notification.error({
            message: 'Something went wrong. Please try again.'
          });
        }

        this.formSubmitting = false;
      }
    }
  },
}
</script>
<style scoped>
</style>